// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "https://i.ibb.co/hHXG6rW/Screenshot-229.png",
    title: "Facebook Clone",
    description: `Explore a Facebook clone with real-time interactions, personalized profiles, and robust file validation. Create posts with text, emojis, images, and backgrounds. Enjoy seamless reactions, comments, and post management, including image manipulation tools.
     `,
    tech_stack: "React, Express, MongoDB, React Redux, Node.js ",
    github_url: "https://github.com/samarjeetpatankar/facebook-clone",
    demo_url: "https://facebook-clone-brown-nu.vercel.app/", 
  },
  {
    img: "https://i.ibb.co/jf04BNw/Screenshot-230.png",
    title: "E-Commerce MERN app",
    description: `This project exemplifies a user-centric e-commerce platform with extensive product filtering, intuitive navigation, and personalized user accounts. Admins have efficient tools for order and product management, making it a versatile e-commerce solution`,
    tech_stack: "React, Express, MongoDB, Node.js ",
    github_url: "https://github.com/samarjeetpatankar/ecommerce-mern-app",
    demo_url: "https://ecommerce-mern-app-theta.vercel.app/",
  },
  {
    img: "https://i.ibb.co/9nkx59q/Screenshot-224.png",
    title: "Retax CRM System Website",
    description: `The Retax CRM System Website, constructed with React, provides an intuitive interface for customer relationship management. It facilitated the growth of my front-end skills, UI design experience, and presentation abilities.`,
    tech_stack: " React JS,Express JS, MongoDB, Chakra UI, ",
    github_url: "https://github.com/samarjeetpatankar/retax-crm-system",
    demo_url: "https://retax-crm-system-frontend.vercel.app/",
  },
  // {
  //   img: "https://i.ibb.co/87WJgxK/Screenshot-226.png",
  //   title: "Photo Sharing Website",
  //   description:
  //     "I've crafted a dynamic photo-sharing app using Next.js, Firebase, and Tailwind CSS. It offers seamless photo uploading and sharing, thanks to integrated Google authentication for secure logins. The user-centric frontend components ensure a responsive and friendly interface.",
  //   tech_stack: "Next.js, Firebase, Tailwind CSS",
  //   github_url: "https://github.com/samarjeetpatankar/photo-sharing",
  //   demo_url: "https://photo-sharing-ten.vercel.app/",
  // },

  {
    img: "https://i.ibb.co/JKLcM1g/hand-Sanitizer.png",
    title: "HandSanitizer Clone",
    description:
      "This is a clone of HAAN Store which is an e-commerce website mainly focused on personal care and branding of the same. Worked on Product Detail page and Checkout page of website.",
    tech_stack: "HTML, CSS, Javascript, ES6",
    github_url: "https://github.com/samarjeetpatankar/Hand-Sanitizer-website",
    demo_url: "https://haan-website-clone-pt12.netlify.app/",
  },
  {
    img: "https://i.ibb.co/wcdZjrG/skinstore.png",
    title: "SkinStore Clone",
    description: `This is a clone of "skinstore.com" which is an e-commerce website for woman Beauty and fashion products. Worked on Homepage and Product Detail page of website.`,
    tech_stack: "HTML, CSS, Javascript, ES6",
    github_url: "https://github.com/samarjeetpatankar/SkinStore-clone",
    demo_url: "https://skinstore-clone-pt12.netlify.app/",
  },
];

// --------------------------------------- Skills-------------------------//

export const stackList = [
  {
    img: "https://cdn.icon-icons.com/icons2/2107/PNG/96/file_type_html_icon_130541.png",
    name: "HTML",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2107/PNG/96/file_type_css_icon_130661.png",
    name: "CSS",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2108/PNG/96/javascript_icon_130900.png",
    name: "JavaScript",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2699/PNG/96/reactjs_logo_icon_168875.png",
    name: "ReactJS",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/redux_original_logo_icon_146365.png",
    name: "Redux",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2107/PNG/96/file_type_node_icon_130301.png",
    name: "NodeJS",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/mongodb_original_wordmark_logo_icon_146425.png",
    name: "MongoDB",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/express_original_logo_icon_146527.png",
    name: "Express",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2107/PNG/96/file_type_typescript_official_icon_130107.png",
    name: "TypeScript",
  },
  {
    img: "https://pbs.twimg.com/profile_images/1244925541448286208/rzylUjaf_400x400.jpg",
    name: "Chakra Ui",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/2415/PNG/96/git_plain_logo_icon_146507.png",
    name: "Git",
  },
  {
    img: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    name: "Postman",
  },
  {
    img: "https://cdn.icon-icons.com/icons2/936/PNG/96/github-logo_icon-icons.com_73546.png",
    name: "GitHub",
  },
];
